import Footer from "../components/Footer/FooterSection";
import Header from "../components/Header/HeaderSection";
import '../styles/productslisting.scss'
import ProductsCategory from "../components/ProductsCategory/ProductsCategory";
import ProductsFilter from "../components/ProductsFilter/ProductsFilter";
import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ChevronRight, ArrowLeft, ArrowRight, Filter, X } from "lucide-react";
import ProductList from "../components/ProductsList/ProductsList";
import { useNotification } from "../context/NotificationContext";
import { loadCategories, loadCategoryProducts, loadRandomProducts, loadSubcategoryProducts, searchProducts } from "../api/requests";
import { PageInfo, Product, ProductCategory } from "../interface/interfaces";


const ProductListing = () => {
  const location = useLocation();
  const { notify } = useNotification();
  const { category, subcategory } = useParams()

  // const [categoryNameData] = useState({
  //   category: null,
  //   subcategory: null
  // })

  const [toggleFilterMobile, setToggleFilterMobile] = useState(false)
  const [toggleCategoryMobile, setToggleCategoryMobile] = useState(false)

  const [isProductsLoading, setProductsLoading] = useState(true)
  const [isCategoriesLoading, setCategoriesLoading] = useState(true)

  const [renderProducts, setRenderProducts] = useState<Product[]>([])
  const [mainCopy, setMainCopy] = useState<Product[]>([])


  const [renderCategories, setRenderCategories] = useState<ProductCategory[]>([])

  type PriceFilterProp = {
    name: string,
    data: any
  }

  const [priceFilter, setPriceFilter] = useState<PriceFilterProp | null>(null)


  const [naviFilter, setNaviFilter] = useState({
    currentPage: 1,
    pageSize: 50,
    category_id: '',
    subcategory_id: '',
    search_query: ''
  })

  const [paginationData, setPaginationData] = useState({
    page: 0,
    size: 0,
    total: 0,
    pages: 0
  })


  //Initial categories load
  useEffect(() => {

    const func = async () => {
      try {

        setCategoriesLoading(true)

        let resp = await loadCategories()

        setRenderCategories(resp)

      } catch (error: any) {
        notify.error(error.message)
      } finally {
        setCategoriesLoading(false)
      }
    }

    func()
    // eslint-disable-next-line
  }, [])



  // Set Search query
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const searchTxt = query.get('search');

    const trimmed = searchTxt?.trim() ?? '';

    setNaviFilter((prev) => { return { ...prev, search_query: trimmed } });
    // eslint-disable-next-line
  }, [location.search])



  // Update page filter to control products load based on category abd subcategory
  useEffect(() => {
    if (renderCategories.length === 0 || !category) {
      setNaviFilter(prev => ({
        ...prev,
        category_id: '',
        subcategory_id: '',
        currentPage: 1
      }));

      return;
    }

    const foundCategory = renderCategories.find(cat => cat.tag === category);

    if (!foundCategory) return;

    // Case: only category is selected
    if (!subcategory) {
      setNaviFilter(prev => ({
        ...prev,
        category_id: foundCategory.category_id,
        subcategory_id: '',
        currentPage: 1
      }));
      return;
    }

    // Case: both category and subcategory are selected
    const foundSubCategory = foundCategory.subCategory?.find(sub => sub.tag === subcategory);

    // console.log('Found Subcategory', foundSubCategory)

    if (foundSubCategory) {
      setNaviFilter(prev => ({
        ...prev,
        category_id: foundCategory.category_id,
        subcategory_id: foundSubCategory.subcategory_id,
        currentPage: 1
      }));
    }

  }, [category, subcategory, renderCategories]);

  // Handle Products Load
  useEffect(() => {


    const func = async () => {
      if (renderCategories.length < 1) {

        setTimeout(() => {
          setProductsLoading(false)
        }, 5000)
        return
      }

      try {
        let result: Product[], pagination: PageInfo

        setProductsLoading(true)

        if (naviFilter.search_query !== '') {

          let { search_query, currentPage, pageSize } = naviFilter

          let { products, pageInfo } = await searchProducts(search_query, currentPage, pageSize)

          result = products
          pagination = pageInfo

        } else if (naviFilter.category_id !== '' && naviFilter.subcategory_id === '') {

          let { category_id, currentPage, pageSize } = naviFilter

          let { products, pageInfo } = await loadCategoryProducts(category_id, currentPage, pageSize)

          result = products
          pagination = pageInfo

        } else if (naviFilter.category_id !== '' && naviFilter.subcategory_id !== '') {

          let { subcategory_id, currentPage, pageSize } = naviFilter

          let { products, pageInfo } = await loadSubcategoryProducts(subcategory_id, currentPage, pageSize)

          result = products
          pagination = pageInfo

        } else {

          let { currentPage, pageSize } = naviFilter
          let { products, pageInfo } = await loadRandomProducts(currentPage, pageSize)

          result = products
          pagination = pageInfo

        }

        setMainCopy(result)
        setRenderProducts(result)


        setPaginationData(() => {
          return {
            page: pagination.page,
            size: pagination.size,
            total: pagination.total,
            pages: pagination.pages
          }
        })


      } catch (error: any) {
        notify.error(error.message)
      } finally {
        setProductsLoading(false)
      }

    }

    func()
    // eslint-disable-next-line
  }, [naviFilter])


  //  useEffect(() => {

  //     if (renderCategories.length >= 1) {

  //       let categoryData:ProductCategory 

  //       if (category && !subcategory) {

  //         let result=renderCategories.find((data)=>{
  //           return data.tag === category
  //         })

  //         if(result){
  //           categoryData=result as ProductCategory

  //           setNaviFilter((prev)=> {
  //             return {
  //               ...prev,
  //                category_id: categoryData.category_id,
  //                subcategory_id: '',
  //             }
  //           })
  //         }

  //       } else if (category && subcategory) {

  //          let result=renderCategories.find((data)=>{
  //           return data.tag === category
  //         })

  //         if(result){

  //           let categoryData=result as ProductCategory

  //           let subcatresult=result.subCategory.find((data)=>{
  //             return data.tag === subcategory
  //           })

  //           if(subcatresult){
  //             let subCategoryData= subcatresult as SubCategory

  //              setNaviFilter((prev)=> {
  //             return {
  //               ...prev,
  //                category_id: categoryData.category_id,
  //                subcategory_id: subCategoryData.subcategory_id,
  //             }
  //           })
  //           }



  //         }


  //       }

  //     }



  //   }, [category, subcategory, renderCategories])

  useEffect(() => {
    if (priceFilter) {

      let arr = mainCopy.filter((eachProduct) => {
        return (eachProduct.price_data.current_price > priceFilter.data.min && eachProduct.price_data.current_price <= priceFilter.data.max)
      })

      setRenderProducts(arr)

      // notify.success('Applied price filter')

    } else {
      setRenderProducts([...mainCopy])
    }
// eslint-disable-next-line
  }, [priceFilter,mainCopy])


  const goToPage = (num: number) => {
    setNaviFilter((prev) => {
      return {
        ...prev,
        currentPage: num
      }
    })
  }


  const handlePageIncrement = (inc: number) => {
    if (!isProductsLoading) {
      setNaviFilter((prev) => {
        return {
          ...prev,
          currentPage: prev.currentPage + inc
        }
      })
    }

  }


  const handlePriceFilter = (priceData: any) => {
    console.log(priceData)


    let obj = {
      name: 'price',
      data: priceData
    }

    setPriceFilter(obj)
  }


  const formatPrice = (value: number) => {
    if (value >= 1_000_000) {
      return `${(value / 1_000_000).toFixed(value % 1_000_000 === 0 ? 0 : 1)}M`;
    }
    if (value >= 1_000) {
      return `${(value / 1_000).toFixed(value % 1_000 === 0 ? 0 : 1)}K`;
    }
    return value.toString();
  };


  const removePriceFilter=()=>{
    setPriceFilter(null)
    // notify.success('Price filter removed')
  }


  return (
    <>
      <Header></Header>
      <div className='productslisting content'>

        <div className='skepGrid'>

          <div className='sideBar'>
            <ProductsCategory isLoading={isCategoriesLoading} categories={renderCategories} toggle={toggleCategoryMobile} setToggle={setToggleCategoryMobile}></ProductsCategory>
            <ProductsFilter toggle={toggleFilterMobile} setToggle={setToggleFilterMobile} processPriceFilter={handlePriceFilter}></ProductsFilter>
          </div>

          <div className='contentSide'>


            {naviFilter.search_query === '' && (<div className="customhistory">
              <div className="category">Products</div>
              <div className="arr"><ChevronRight size={18}></ChevronRight></div>
              {naviFilter.category_id && (<>
                <div className="category">{category}</div>
                <div className="arr"><ChevronRight size={18}></ChevronRight></div>
              </>

              )}

              {naviFilter.subcategory_id && (
                <div className="subcategory">{subcategory}</div>
              )}
            </div>)}

            {naviFilter.search_query !== '' && (<div className="customhistory">
              <div className="category">Results for {naviFilter.search_query}</div>
            </div>)}





            <div className="actionTab">

              <div className='category_title' onClick={() => setToggleCategoryMobile((prev) => !prev)}>
                <div className='svgicon'>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0H3V3H0V0ZM7.5 0H10.5V3H7.5V0ZM15 0H18V3H15V0ZM0 7.5H3V10.5H0V7.5ZM7.5 7.5H10.5V10.5H7.5V7.5ZM15 7.5H18V10.5H15V7.5ZM0 15H3V18H0V15ZM7.5 15H10.5V18H7.5V15ZM15 15H18V18H15V15Z" fill="white" />
                  </svg>

                </div>
                <div>Categories</div>
              </div>


              <div className='filter_title' onClick={() => setToggleFilterMobile((prev) => !prev)}>
                <Filter size={18} strokeWidth={1}></Filter>
                <div>Filter</div>
              </div>


            </div>




            <div className="filterBox">
              {priceFilter && (
                <div className="priceFilter">
                  <div className="label">Min</div>
                  <div className="value">₦{formatPrice(priceFilter.data.min)}</div>

                  <div className="midline"></div>

                  <div className="label">Max</div>
                  <div className="value">₦{formatPrice(priceFilter.data.max)}</div>

                  <div className="xcircle" onClick={removePriceFilter}>
                    <X size={12} color="#fff" />
                  </div>
                </div>


              )}

            </div>


            <div className="productsDisplay">

              <ProductList isLoading={isProductsLoading} products={renderProducts} setProducts={setRenderProducts}></ProductList>
            </div>

            <div className="paginationDiv">

              {(paginationData.page - 1) >= 1 && (<div className="eachP  previous" onClick={() => handlePageIncrement(-1)}>
                <ArrowLeft size={18}></ArrowLeft>
                <span>Previous</span>
              </div>)}




              <div className="pages">

                {paginationData.pages >= 1 && (<div className={`eachP num ${paginationData.page === 1 ? 'activepnum' : ''}`} onClick={() => goToPage(1)}>1</div>)}




                {paginationData.pages >= 2 && (<div className={`eachP num ${paginationData.page === 2 ? 'activepnum' : ''}`} onClick={() => goToPage(2)}>2</div>)}



                {paginationData.pages >= 3 && (<div className={`eachP num ${paginationData.page === 3 ? 'activepnum' : ''}`} onClick={() => goToPage(3)}>3</div>)}


                {paginationData.page > 3 && (<>

                  <div className="eachP num">...</div>

                  <div className={`eachP num activepnum`}>{paginationData.page}</div>
                </>)}

              </div>


              {paginationData.page + 1 <= paginationData.pages && (<div className="eachP next" onClick={() => handlePageIncrement(+1)}>
                <span>Next</span>
                <ArrowRight size={18}></ArrowRight>
              </div>)}



            </div>

          </div>

        </div>

      </div >
      <Footer></Footer>
    </>
  )

}

export default ProductListing;